import type { ShippingEligibilityState } from '@/lib/types/shippingEligibilityState';
import type { ShippingEligibilityActions } from '@/lib/context/shippingEligibilityActions';

export const ShippingEligibilityReducer = (
  state: ShippingEligibilityState,
  action: ShippingEligibilityActions,
): ShippingEligibilityState => {
  switch (action.type) {
    case 'FETCH_START':
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case 'FETCH_SUCCESS':
      return {
        ...state,
        eligibility: action.payload,
        isLoading: false,
        lastFetch: Date.now(),
        error: null,
      };

    case 'FETCH_ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
